import * as React from "react"
import Box from "@mui/material/Box"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import "react-circular-progressbar/dist/styles.css"

function CircularProgressWithLabel(props: any) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        height: 72,
        width: 72,
      }}
    >
      <CircularProgressbar
        value={props.value}
        text={`${props.value}%`}
        styles={buildStyles({
          textColor: "#F6BB42",
          pathColor: "#F6BB42",
          trailColor: props.isActive ? "#E1E1E1" : "#E1E1E1",
        })}
      />
    </Box>
  )
}

export default function CustomProgressFD({
  progress,
  isActive,
  isFull,
}: {
  progress: number
  isActive: boolean
  isFull: boolean
}) {
  return (
    <CircularProgressWithLabel
      isActive={isActive}
      isFull={isFull}
      value={progress}
    />
  )
}
